﻿import React from 'react';
import { useWizard } from 'react-use-wizard';

import WizardNavigation from './WizardNavigation';

const WizardQuestion = (props) => {

    const {
        form: [formState, setFormState],
    } = {
        form: React.useState([]),
        ...(props.state || {}),
    };

    const {
        nextStep
    } = useWizard();

    const onChangeHandler = e => {
        const id = props.question.id;

        setFormState(formState => ({
            ...formState,
            answers: [
                ...formState.answers,
                {
                    questionid: id,
                    answer: event.target.value,
                }
            ]
        }))
        setTimeout(() => {
            nextStep();
        }, 200)
    };

    const options = props.question.options;

    let key = Math.random();

    return (
        <React.Fragment>
            <div className="wizard__question" key={key}>
                <WizardNavigation />

                <h2 className="wizard__question__heading">{props.question.questionText}</h2>

                {options &&
                    <section className="wizard__question__options">

                        {options.length > 0 &&
                            options.map((option, i) => {
                                return (
                                    <React.Fragment key={i}>
                                        <label htmlFor={`question-${i}`} className="button button--green button--medium">{option.text}
                                            <input
                                                onChange={onChangeHandler}
                                                id={`question-${i}`}
                                                name={`question-${i}`}
                                                type="radio"
                                                value={option.text}
                                            />
                                        </label>
                                    </React.Fragment>
                                )
                            })
                        }

                        {/*options for Pets / Animals*/}

                        {options.length <= 0 &&
                            <React.Fragment key={key}>
                                <label htmlFor='confirm' className="button button--green button--medium">Ja
                                    <input
                                        onChange={onChangeHandler}
                                        id='confirm'
                                        name='confirm'
                                        type="radio"
                                        value={true}
                                    /></label>

                                <label htmlFor='decline' className="button button--green button--medium">Nej
                                    <input
                                        onChange={onChangeHandler}
                                        id='decline'
                                        name='decline'
                                        type="radio"
                                        value={false}
                                    /></label>
                            </React.Fragment>
                        }
                    </section>

                }
            </div>
        </React.Fragment>
    )
}

export default WizardQuestion;

